import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconUpload: React.FC<IconProps> = ({ color, width = 17, height = 17 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="fi_1092220" clip-path="url(#clip0_5578_32088)">
                <g id="surface1">
                    <path
                        id="Vector"
                        d="M11.4559 0.940058C11.3796 0.85974 11.2751 0.811523 11.1667 0.811523H4.67899C3.48183 0.811523 2.49365 1.79577 2.49365 2.9928V15.2612C2.49365 16.4583 3.48183 17.4426 4.67899 17.4426H13.4845C14.6817 17.4426 15.6699 16.4583 15.6699 15.2612V5.51958C15.6699 5.41516 15.6217 5.31479 15.5534 5.23841L11.4559 0.940058ZM11.5724 2.22959L14.3161 5.10987H12.5325C12.0023 5.10987 11.5724 4.68405 11.5724 4.1538V2.22959ZM13.4845 16.6391H4.67899C3.92783 16.6391 3.29709 16.0165 3.29709 15.2612V2.9928C3.29709 2.24164 3.92377 1.61496 4.67899 1.61496H10.769V4.1538C10.769 5.12992 11.5564 5.91331 12.5325 5.91331H14.8664V15.2612C14.8664 16.0165 14.2398 16.6391 13.4845 16.6391Z"
                        fill="#5C5C5C"
                    />
                    <path
                        id="Vector_2"
                        d="M12.3865 13.8682H5.77428C5.55337 13.8682 5.37256 14.0488 5.37256 14.2699C5.37256 14.4908 5.55337 14.6716 5.77428 14.6716H12.3906C12.6115 14.6716 12.7923 14.4908 12.7923 14.2699C12.7923 14.0488 12.6115 13.8682 12.3865 13.8682Z"
                        fill="#5C5C5C"
                    />
                    <path
                        id="Vector_3"
                        d="M7.02497 9.54543L8.68006 7.76575V12.1525C8.68006 12.3734 8.86087 12.5543 9.08178 12.5543C9.30281 12.5543 9.48349 12.3734 9.48349 12.1525V7.76575L11.1386 9.54543C11.2189 9.62969 11.3234 9.67397 11.4318 9.67397C11.5282 9.67397 11.6287 9.63781 11.705 9.56548C11.8658 9.41284 11.8778 9.1597 11.7252 8.99907L9.37107 6.47228C9.29469 6.39197 9.19026 6.34375 9.07784 6.34375C8.9653 6.34375 8.86087 6.39197 8.78461 6.47228L6.43052 8.99907C6.27788 9.1597 6.28993 9.41677 6.45057 9.56548C6.61932 9.71813 6.87233 9.70607 7.02497 9.54543Z"
                        fill="#5C5C5C"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5578_32088">
                    <rect
                        width="16.631"
                        height="16.631"
                        fill="white"
                        transform="translate(0.734375 0.844727)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconUpload;
